import AnnouncementProxy from './announcement-proxy';
import CaSignProxy from './ca-sign-proxy';
import EInvoiceProxy from './e-invoice-proxy';
import PublishedInvoiceProxy from './published-invoice-proxy';
import SellerProxy from './seller-proxy';
import SettingsProxy from './settings-proxy';
import UnpublishInvoiceProxy from './unpublish-invoice-proxy';

export {
  AnnouncementProxy,
  CaSignProxy,
  EInvoiceProxy,
  PublishedInvoiceProxy,
  SellerProxy,
  SettingsProxy,
  UnpublishInvoiceProxy,
};

const eInvoice = {
  AnnouncementProxy,
  CaSignProxy,
  EInvoiceProxy,
  PublishedInvoiceProxy,
  SellerProxy,
  SettingsProxy,
  UnpublishInvoiceProxy,
};

export default eInvoice;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/index.js